import { ScriptLanguage } from "@/script/model"

const JAVASCRIPT_TEMPLATE = `function execute(input) {
  // TODO

  return output;
}`

const PYTHON_TEMPLATE = `def execute(input: str) -> str:
  # TODO

  return output
`

const PHP_TEMPLATE = `function execute(string $input): string {
  // TODO

  return $output;
}`

export default {
  [ScriptLanguage.Php]: PHP_TEMPLATE,
  [ScriptLanguage.Python]: PYTHON_TEMPLATE,
  [ScriptLanguage.JavaScript]: JAVASCRIPT_TEMPLATE,
}
